import { Component, OnInit } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { ContactLog, ContactMethod, ContactType, Dealer, Order, Vendor } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-contact-log-dialog',
    templateUrl: './contact-log-dialog.component.html',
    styleUrls: ['./contact-log-dialog.component.scss'],
    standalone: false
})
export class ContactLogDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    contactLog: ContactLog;
    contactMethods: ContactMethod[];
    contactTypes: ContactType[];
    dealers: Dealer[];
    vendors: Vendor[];

    mode: string;
    disableSlipNumber: boolean = false;
    freight: number;
    tax: number;
    notes: any;
    selectedRows: any;

    deliveryMethods = ['Delivery', 'Customer PickUp', 'Dealer Pickup'];
    packingSlip: any;
    validationGroup = 'mainValidationGroup';
    errorAction = 'submitting';

    order: Order;
    mileageRate: number;
    calculatedFreight: number = 0;
    showFreight = false;

    onExporting = SharedModule.onExporting;

    constructor(private appInfo: AppInformationService, private uow: GenesisUnitOfWork, public modalRef: BsModalRef, private auth: AuthService, private utility: UtilityService) {}

    async ngOnInit() {
        this.contactMethods = (await this.uow.contactMethods.whereActive()) as ContactMethod[];
        this.contactTypes = (await this.uow.contactTypes.whereActive()) as ContactType[];
        this.dealers = await this.uow.getDealers();
        this.vendors = await this.uow.getVendors();

        if (!this.contactLog) {
            this.contactLog = this.uow.contactLogs.createEntity() as ContactLog;
            this.contactLog.created = new Date();
            this.contactLog.noteDate = new Date();
            this.contactLog.createdBy = this.auth.currentUser.userName;
            this.contactLog.contactMethod = this.contactMethods[0];
            this.contactLog.contactType = this.contactTypes[0];
        }
    }

    async getData() {}

    async partLookup() {}

    typeSelectionChanged(e) {}

    deliverySelectionChanged = (e) => {
        if (this.packingSlip.deliveryMethod === 'PickUp') this.packingSlip.freight = 0;
        // tslint:disable-next-line:semicolon
    };

    async save() {
        const success = await Promise.resolve(this.validate());
        if (!success) return;
        await this.uow.commit();
        this.result.next({ success: true });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }
}
